const size = {
   xxl: `var(--fs-xxl)`,
   xl: `var(--fs-xl)`,
   l: `var(--fs-l)`,
   m: `var(--fs-m)`,
   s: `var(--fs-s)`,
   xs: `var(--fs-xs)`,
}

const breakpoints = {
   tablet: 1300,
   mobile: 500,
}

const space = {
   xxl: `4em`,
   xl: `3em`,
   l: `2em`,
   m: `1em`,
   s: `0.8em`,
   xs: `0.5em`,
   xxs: `0.1em`,
}

const maxWidth = {
   profilePages: `var(--max-width-profile-pages)`,
   mainSection: `var(--max-width-main-section)`,
   illustrationSection: `var(--max-width-illustration-section)`,
   onboardingForm: `var(--max-width-onboarding-form)`,
}

const padding = {
   inline: `var(--padding-inline)`,
   block: `var(--padding-block)`,
}

export { size, breakpoints, space, maxWidth, padding }
